import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function OrientationIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg version="1.2" baseProfile="tiny-ps" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
        <path fill="none" d="M0 0L24 0L24 24L0 24L0 0Z" />
        <path fillRule="evenodd" fill="#000" d="M22 14L22 20C22 21.1 21.1 22 20 22L19 22C19 21.35 19 20.68 19 20L20 20L20 14L19 14C19 13.26 19 12.59 19 12L20 12C21.1 12 22 12.9 22 14ZM19 14L19 20L19 20C19.01 17.94 19 15.79 19 14L19 14Z" />
        <path fillRule="evenodd" fill="#000" d="M12 4L12 20C12 21.1 11.1 22 10 22L4 22C2.9 22 2 21.1 2 20L2 4C2 2.9 2.9 2 4 2L10 2C11.1 2 12 2.9 12 4ZM10 4L4 4L4 20L10 20L10 4ZM17.8 1.96C18.18 1.95 18.37 2.41 18.1 2.68L17.02 3.76L20.19 6.93L21.27 5.85C21.54 5.58 22.01 5.77 22 6.15L21.99 9.52C21.99 9.75 21.8 9.94 21.56 9.93L18.2 9.94C17.82 9.95 17.63 9.49 17.9 9.22L18.98 8.13L15.81 4.97L14.73 6.06C14.46 6.32 13.99 6.14 14 5.76L14.01 2.39C14.01 2.15 14.2 1.97 14.44 1.96L17.8 1.96Z" />
        <path fillRule="evenodd" fill="#000" d="M15 22L13 22L13 20L15 20L15 22ZM18 22L16 22L16 20L18 20L18 22Z" />
        <path fillRule="evenodd" fill="#000" d="M15 14L13 14L13 12L15 12L15 14ZM18 14L16 14L16 12L18 12L18 14Z" />
      </svg>
    </SvgIcon>
  );
}
